import Vue from "vue";
import VueRouter from "vue-router";
import RoutesFacturacion from '@/views/facturacion/routes';
import ItemsRoutes from '@/views/items/routes';
import OrdersRoutes from '@/views/orders/routes';
import CentroAyuda from '@/views/centro-ayuda/routes';
import Credito from '@/views/credito/routes';
import Quotes from '@/views/quotes/routes';
import DashIndicadores from '@/views/dash-indicadores/routes';
import DashNavegacao from '@/views/dash-navegacao/routes';

const AppRouter = [
  {
    path: `/`,
    name: `home`,
    component: () => import('@/views/home/ViewHome.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  ...RoutesFacturacion,
  ...ItemsRoutes,
  ...OrdersRoutes,
  ...CentroAyuda,
  ...Credito,
  ...Quotes,
  ...DashIndicadores,
  ...DashNavegacao
];

Vue.use(VueRouter);

const router = new VueRouter({
  routes: AppRouter
});

export default router;
